<template>
  <div @click="handleAddtime" style="width: 100vw; height: 100vh">
    <div v-if="showphoneAuth" class="authbox">
      <p class="title postTitle">请先绑定您的手机号~</p>
      <van-cell-group class="no-border no-back">
        <van-field
          label="手机"
          placeholder="请输入手机号"
          type="text"
          v-model="form.mobile"
        ></van-field>
      </van-cell-group>
      <van-cell-group class="no-border no-back flex-button">
        <van-field
          label="验证码"
          placeholder="请输入验证码"
          type="text"
          v-model="form.smsCode"
        ></van-field>
        <van-button
          type="primary"
          color="#6495FE"
          @click="getCatcha"
          :disabled="downTime > 0"
          >{{ btnCodeText }}</van-button
        >
      </van-cell-group>
      <div class="center-box">
        <van-button type="primary" @click="subCode">提交验证</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mPattern } from '@/assets/js/rules';
const murl = window.location.href.split('#')[0].split('?')[0];
const query = localStorage.getItem('now_url')
  ? localStorage.getItem('now_url').split('?')[0]
  : '';
const url = localStorage.getItem('now_url')
  ? localStorage.getItem('now_url')
  : ''; // 储存的跳转授权入口地址
export default {
  data() {
    return {
      showphoneAuth: false,
      form: {
        mobile: '',
        smsCode: ''
      },
      downTime: 0,
      userData: {},
      times: 0,
      addNum: 1
    };
  },
  computed: {
    btnCodeText() {
      return this.downTime > 0 ? this.downTime + 's后重新获取' : '获取验证码';
    }
  },
  // 生命周期函数
  async mounted() {
    const code = this.GetUrlParame('code'); // 截取code
    let Token = window.localStorage.getItem('authToken');
    // let Token = "58_bFCvxGklYRrQJ4mOX-RUJ-sn1xzc_TYAsyepkbnQao1TI9Nh5mv-KC5dte94Hbx4kXQ8TCgDgh3tFJqluUnEvNa3H1cU4p9swQPgibalRjGZb89ex8rUOliJ_Pz5q3HPrEf1x3fs0YOH9FWqRLEcAAAYS";
    if (!this.isWechat) {
      let that = this;
      console.log('非微信环境', murl, query, url);
      if (this.getStore('payMsg') && this.getStore('aId')) {
        const payMsg = this.getStore('payMsg');
        const aId = this.getStore('aId');
        // this.removeStore('payMsg');
        // this.removeStore('aId');
        let res = await this.request('/pay/userOrder/getOrderInfo', {
          id: payMsg.orderId
        });
        console.log(res);
        if (res.code === 0) {
          if (res.data.status === 2) {
            that.payType = true;
            that.$error('支付成功');
            clearInterval(that.timer);
            that.removeStore('payMsg');
            that.removeStore('aId');
            setTimeout(() => {
              window.location.href =
                window.location.origin +
                window.location.pathname +
                '#' +
                '/Activity/NormalSuccess?id=' +
                payMsg.orderId +
                '&activityId=' +
                aId;
            }, 300);
          } else {
            this.payType = false;
            this.$error('支付失败');
            // that.removeStore('payMsg');
            // that.removeStore('aId');
          }
        }
      }
      return;
    }
    if (code) {
      if (Token) {
        await this.getUser();
        if (this.userData.mobile) {
          this.toNowurl();
        } else if (
          query === '/Activity/Normal' ||
          query === '/Activity/Tuan' ||
          query === '/order' ||
          query === '/personalcenter'
        ) {
          this.toNowurl();
        } else {
          this.showphoneAuth = true;
        }
        return;
      }
      if (window.localStorage.getItem('codeCheck')) {
        return;
      }
      this.$store.commit('updateCode', code);
      // this.$error("已经授权");
      // setTimeout(() => {
      let param = { code: code };
      // param = { ...this.$store.state.loginForm, ...param };

      let logins = await this.wxLogin(param);
      console.log(logins);
      // Token = "58_bFCvxGklYRrQJ4mOX-RUJ-sn1xzc_TYAsyepkbnQao1TI9Nh5mv-KC5dte94Hbx4kXQ8TCgDgh3tFJqluUnEvNa3H1cU4p9swQPgibalRjGZb89ex8rUOliJ_Pz5q3HPrEf1x3fs0YOH9FWqRLEcAAAYS";
      window.localStorage.setItem('authToken', logins.data.token);
      Token = logins.data.token;
      logins.code = 0;
      console.log(logins);
      localStorage.setItem('isAuth', 'true');
      if (logins.code === 0 && Token) {
        await this.getUser();
        if (this.userData.mobile) {
          this.toNowurl();
        } else if (
          query === '/Activity/Normal' ||
          query === '/Activity/Tuan' ||
          query === '/order' ||
          query === '/personalcenter'
        ) {
          this.toNowurl();
        } else {
          this.showphoneAuth = true;
        }

        // window.location.replace(murl + "#" + url);
      } else {
        // console.log(login);
        console.log(logins.msg);
      }
      // }, 1500);
    } else if (!code) {
      if (localStorage.getItem('isAuth') === 'true') {
        console.log('已经授权');
        if (window.localStorage.getItem('authToken')) {
          if (this.$route.path === '/Activity/TuanSuccess' || this.$route.path === '/Activity/NormalSuccess') {
            return;
          } else if (this.userData.mobile) {
            this.toNowurl();
          } else if (
            query === '/Activity/Normal' ||
            query === '/Activity/Tuan' ||
            query === '/order' ||
            query === '/personalcenter'
          ) {
            this.toNowurl();
          } else {
            this.showphoneAuth = true;
          }
        }
        this.toNowurl();
        return;
      }
      var domine = window.location.href.split('#')[0]; // 微信会自动识别#    并且清除#后面的内容
      var appid = process.env.VUE_APP_BASE_APPID || 'wx888f1916a1ff7ca5';
      // var appid = "wx5d047f9b0ee0620a"; // 正式appid
      // var appid = "wx888f1916a1ff7ca5"; // 测试appid
      localStorage.setItem('isAuth', 'true');
      window.location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        appid +
        '&redirect_uri=' +
        encodeURI(domine) +
        '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
    } else {
      // this.$store.state.code = code;
    }
  },
  methods: {
    handleAddtime() {
      if (this.times > 20) {
        console.log('++', this.times, this.addNum);
        // window.eruda.init();
        if (this.addNum === 1) {
          ;(function() {
            var script = document.createElement('script');
            script.src = '//cdn.jsdelivr.net/npm/eruda';
            document.body.appendChild(script);
            script.onload = function() {
              window.eruda.init();
            };
          })();
          this.addNum = 2;
        }
        return;
      }
      this.times += 1;
    },
    // 截取code
    GetUrlParame(parameName) {
      /// 获取地址栏指定参数的值
      /// <param name="parameName">参数名</param>
      // 获取url中跟在问号后面的部分
      var parames = window.location.search;
      console.log(parames);
      // 检测参数是否存在
      if (parames.indexOf(parameName) > -1) {
        var parameValue = '';
        parameValue = parames.substring(
          parames.indexOf(parameName),
          parames.length
        );
        // 检测后面是否还有参数
        if (parameValue.indexOf('&') > -1) {
          // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
          parameValue = parameValue.substring(0, parameValue.indexOf('&'));
          // 去掉参数名, 得到最终纯值字符串
          parameValue = parameValue.replace(parameName + '=', '');
          return parameValue;
        }
        return '';
      }
    },
    // 获取数据
    async getUser() {
      try {
        this.$loading('加载中');
        let result = await this.request('/user/user/get', {});
        console.log(result);
        this.userData = result.data;
        this.$loadingClose();
      } catch (e) {
        this.$loadingClose();
        this.$error(e.message);
      }
    },
    // 跳转旧链接
    toNowurl() {
      console.log('murl', murl, url);
      //   this.$router.replace(url);
      if (history.replaceState) {
        console.log('replaceState');
        if (url === '/auth' || url === '') {
          history.replaceState(null, document.title, murl + "#" + '/personalcenter');
          // history.replaceState(null, document.title, murl + "#");
        } else {
          history.replaceState(null, document.title, murl + '#' + url);
        }
        history.go(0);
      } else {
        console.log('location.replace');
        window.location.replace(murl + '#' + url);
        // location.replace("/gold-coin/buy-res");
      }
    },
    // 定时器
    countDown(that) {
      if (this.downTime === 0) {
      } else {
        this.downTime--;
        // 循环调用
        setTimeout(function() {
          that.countDown(that);
        }, 1000);
      }
    },
    // 获取验证码
    async getCatcha() {
      let param = this.form;
      if (!param.mobile) {
        this.$error('请输入手机号');
      } else if (!mPattern.test(param.mobile)) {
        this.$error('手机号格式有误');
      } else {
        try {
          let res = await this.request('/user/user/bindMobile', {
            mobile: this.form.mobile
          });
          if (res.code === 0) {
            this.downTime = 60;
            let that = this;
            that.countDown(that);
          } else {
            this.$error(res.msg);
          }
        } catch (error) {
          this.$error(error.message);
        }
      }
    },
    async subCode() {
      if (!this.form.mobile) {
        this.$error('请输入验证码');
      }
      try {
        let res = await this.request('/user/user/bindUserOfMobile', {
          mobile: this.form.mobile,
          smsCode: this.form.smsCode
        });
        if (res.code === 0) {
          this.showphoneAuth = false;
          this.toNowurl();
        } else {
          this.$error(res.msg);
        }
      } catch (error) {
        this.$error(error.message);
      }
    }
  }
};
</script>
<style lang="less">
@import '~@/assets/css/style';

.authbox {
  .title {
    text-align: center;
    margin: 50px;
    font-size: 20px;
  }

  .flex-button {
    .flex-center();
    /deep/.van-button {
      padding: 0;
      background: transparent !important;
      color: #0096ff !important;
      border: 0;
      line-height: 1;
      width: 150px;
    }
  }
  .center-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 120px;
    .van-button {
      width: 300px;
    }
  }
}
</style>
